import React from "react";
import { Link } from "react-router-dom";
import { MEDIA_URL } from "../../../configs";

import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import TimeAgo from "react-timeago";

dayjs.extend(relativeTime);

const RecentPublishedList = ({ recentPublishData }) => (
  <div className="mb-4 px-4 py-3 bg-white shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-2">
      <strong>Recent published</strong>
      <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
      </span>
    </div>
    {recentPublishData && recentPublishData.length > 0 ? (
      <ul className="list-unstyled">
        {recentPublishData.map((resource, index) => (
          <li className="mb-2 d-flex justify-content-start align-items-center" key={index}>
            <div className="text-center">
              {resource?.thumbnail && (
                <Link to={`/resources/edit/${resource._id}`}>
                  <img
                    src={`${MEDIA_URL}${resource?.thumbnail?.path}`}
                    width={64}
                    className="mx-auto my-2 img-fluid px-8"
                    alt={`Thumbnail for ${resource.resourceName || 'resource'}`}
                  />
                </Link>
              )}
            </div>
            <div className="col-md-10 ms-4">
              <p className="mb-1 small list-title">
                <Link to={`/resources/edit/${resource._id}`} className="text-dark">
                  {resource.name}
                </Link>
              </p>
              <div className="text-muted mb-2 d-flex align-items-center">
                {/* Add status and creator info if needed */}
                <div className="me-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                  <i className="bi bi-clock me-1"></i>
                  <span className="text-break">
                    <TimeAgo date={resource.updated_at} />
                  </span>
                </div>
                <div className=" text-muted mb-0">
                  <span className="mx-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-person me-1"></i>
                    <span>{resource.creator.username}</span>
                  </span>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted">No recent published resources to show.</p>
    )}
  </div>
);

export default RecentPublishedList;
